import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class BulevartService {
    private basePath = environment.interop.authCore.basePath;
    private listGalleryUrl = this.basePath + environment.interop.authCore.bulevart.getGallery;

    constructor(private http: HttpClient) { }

    listGallery() {
        return this.http.get<{ errors: boolean; data: any[]; status_code: number }>(this.listGalleryUrl);
    }
}
